import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserSessionService } from 'bna-angular-auth-client';

@Component({
  selector: 'app-sign-out',
  templateUrl: './sign-out.component.html',
  styleUrls: ['./sign-out.component.scss'],
})
export class SignOutComponent implements OnInit {
  constructor(
    private router: Router,
    private userSessionService: UserSessionService
  ) {}

  ngOnInit() {
    this.userSessionService.signOut(true);
    localStorage.clear();
    this.router.navigate(['sign-in']);
  }
}
